import { axiosSEC } from "../http-common";

const generateQrCode = (data: string, idEstacionamento: number) => {
    return axiosSEC.post(`CobrancaPix/GerarCobranca/${idEstacionamento}`, data);
}

const getQrCodeStatus = (idQrCode: string) => {
    return axiosSEC.get(`CobrancaPix/GetStatusPorIdQrCode/${idQrCode}`);
}

const PixPdvService = {
    generateQrCode,
    getQrCodeStatus
}

export default PixPdvService;